/**
 * SAP CG1 business segmentation: `01` = Food Service.
 * Used to filter master-data CG3 business types for recipe targeting.
 * Aligns with buyer recipe logic (`ship_tos.cg_1_business_segmentation === '01'`).
 */
export const RECIPE_CG3_BUSINESS_SEGMENTATION_ID = '01';
